import { createContext, useContext, useState } from 'react';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [isAdsOpen, setIsAdsOpen] = useState(false);

  const openAdsModal = () => {
    console.log('Opening modal'); 
    setIsAdsOpen(true);
  };
  
  const closeAdsModal = () => {
    console.log('Closing modal'); 
    setIsAdsOpen(false);
  };

  return (
    <ModalContext.Provider value={{ isAdsOpen, openAdsModal, closeAdsModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);